import styled from "@emotion/styled";
import { type ReactNode } from "react";

import {
  AppContextProvider,
  AppToaster,
  ImportToaster,
  ImportToasterProvider,
  ModalDialogContextProvider,
} from "@skilitics/designer-ui-components";
import { LocaleProvider } from "@skilitics/localization";

import { HeaderPrefix } from "./HeaderPrefix";
import { HeaderSuffix } from "./HeaderSuffix";

const MainContainer = styled.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  width: 100dvw;
  height: 100dvh;
  overflow-y: hidden;
  overflow-x: auto;
`;

const createHeaderBar = (): Parameters<typeof AppContextProvider>[0]["headerBar"] => ({
  renderPrefix: () => <HeaderPrefix />,
  renderSuffix: () => <HeaderSuffix />,
});

export const AppCore = ({ children }: { children: ReactNode }) => {
  const headerBar = createHeaderBar();

  return (
    <LocaleProvider>
      <MainContainer>
        <AppContextProvider headerBar={headerBar}>
          <ImportToasterProvider>
            <ModalDialogContextProvider>{children}</ModalDialogContextProvider>
            <AppToaster />
            <ImportToaster />
          </ImportToasterProvider>
        </AppContextProvider>
      </MainContainer>
    </LocaleProvider>
  );
};
